"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsEpciManager", function ($q, $http, $debounce, obsUtils) {
    return {
        restrict: "A",
        scope: true,
        require: ["obsEpciManager", "obsMapManager"],
        controllerAs: "mapManagerCtrl",
        link: function ($scope, $el, $attrs, controllers) {

            var ctrl = controllers[0],
                mapManagerCtrl = controllers[1],
                obsConfig = $scope.observatoryConfig;

            ctrl.initialize(obsConfig, mapManagerCtrl);
        },
        controller: function ($scope) {

            var ctrl = this,
                config = null,
                mapManagerCtrl = null,
                requestCanceler = null,
                selectedId = null,
                referenceId = null,
                hoveredEpci = null;

            ctrl.initialize = function (_config, _mapManagerCtrl) {
                config = _config;
                mapManagerCtrl = _mapManagerCtrl;
                ctrl.loadReference();
                mapManagerCtrl.setViewport({
                    lat: 46.8,
                    lng: 2.25,
                    zoom: 6
                });
                startWatching();
            };

            ctrl.getConfig = function() {
                return config;
            };

            var startWatching = function () {

                $scope.$watch('viewport', function (view) {
                    ctrl.refreshData();
                }, true);

                $scope.$watch('epciParams', function () { // TODO : rename to generic
                    if ($scope.epciParams.temporalite !== "EVOLUTION" && $scope.epciParams.representation !== "RELATIF") {
                        $scope.epciParams.unite = "VALEUR";
                    }
                    ctrl.refreshData();
                }, true);

            };

            ctrl.setHoveredEpci = function (epci) {
                hoveredEpci = epci;
            };

            ctrl.getHoveredEpci = function () {
                return hoveredEpci;
            };

            /**
             *
             * @param commune
             */
            ctrl.setReferenceEpci = function(epci) {
                ctrl.loadReference(epci.id).then(function() {
                    // nothing ?
                });
            };


            /**
             *
             */
            ctrl.centerMapOn = function (entity) {
                selectedId = entity.id;
                mapManagerCtrl.setViewport({
                    lat: entity.coordinates.lat,
                    lng: entity.coordinates.lng,
                    zoom: 10
                });
            };

            ctrl.getSelectedId = function () {
                return selectedId;
            };

            ctrl.setSelectedId = function (entityId) {
                selectedId = entityId;
            };


            ctrl.onSearchFieldSelection = function (entity) {
                if (config.publicObs) {
                    ctrl.setReferenceEpci(entity);
                } else {
                    ctrl.centerMapOn(entity);
                }
            };


            ctrl.centerMapOn = function(entity) {
                selectedId = entity.id;
                mapManagerCtrl.setViewport({
                    lat: entity.coordinates.lat,
                    lng: entity.coordinates.lng,
                    zoom : 10
                });
            };


            /**
             *
             */
            ctrl.loadReference = function (refIdToLoad, centerOnMap) {

                console.log('refIdToLoad', refIdToLoad);

                if($scope.reference == null) {
                    // set empty default
                    $scope.reference = {
                        id: null,
                        name: "Pas de référence",
                        coordinates: null
                    };
                }
                // then load
                return $http.get(config.referenceUrl, {
                        params: {
                            year: $scope.epciParams.anneeInstantane,
                            id: refIdToLoad
                        }
                    }
                ).then(function (response) {
                    var reference = response.data;
                    referenceId = reference.id;
                    $scope.reference = reference;
                    if (reference.coordinates) {
                        if(centerOnMap !== false) {
                            ctrl.centerMapOn(reference);
                        }
                    }
                });
            };

            /**
             *
             */
            ctrl.refreshData = $debounce(function () {

                if (requestCanceler) {
                    requestCanceler.resolve();
                }

                requestCanceler = $q.defer();
                $scope.$broadcast("obs:data-load:start");

                var viewport = mapManagerCtrl.getViewport();
                var mapDataParams = _.extend({}, $scope.epciParams, {
                    referenceId: referenceId,
                    position: {
                        lat: viewport.lat,
                        lng: viewport.lng
                    }
                });

                $http.post(config.dataUrl, mapDataParams, {timeout: requestCanceler.promise}).then(function (response) {
                    var infoEcpi = response.data;

                    // TODO : clean this
                    // Toujours la valeur absolue pour l'affichage de la valeur de référence
                    var formatParameters = _.extend({}, $scope.epciParams, {
                        representation: 'ABSOLU',
                        unite: 'VALEUR'
                    });

                    $scope.referenceLabel = obsUtils.getTypeLabel(formatParameters.datatype);
                    $scope.referenceValue = obsUtils.formatValue(formatParameters, infoEcpi.referenceValue);
                    // TODO : end
                    $scope.$broadcast("obs:data-load:success", infoEcpi);
                });

            }, 250);

            $scope.$on("$destroy", function () {
                // cancel the currently waiting debounced call, if it exists.
                ctrl.refreshData.cancel();
                if (requestCanceler != null) {
                    requestCanceler.resolve();
                }
            });

        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/epci/obsEpciManager.js